export default "__VITE_ASSET__J1Gj$Wpn__"